<template>
  <selected-categories
    class="pitchup-categories"
    :class="{ desktop: $isDesktop }"
    :selected-ids="categoryIds"
    :enabled-on-all-unselected="true"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchWizardHomepageBannerCategories extends Vue {
  @Prop({ required: true })
  categoryIds: string[]
}

export default toNative(SearchWizardHomepageBannerCategories)
</script>

<style scoped>
.pitchup-categories {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 0.75em 0;
}

.pitchup-categories img {
  width: auto;
  height: 1.5em;
}

.pitchup-categories img ~ img {
  margin-left: 0.4em;
}

.pitchup-categories ~ .touring-pitches {
  margin-left: 0.25em;
}

/* desktop & tablet */
.pitchup-categories.desktop {
  background: white;
  border-radius: 9em;
  font-size: 1.3em;
  padding: 0.5em 1em;
  margin: 0 1em;
}
</style>
